import { render, staticRenderFns } from "./Tef.vue?vue&type=template&id=6c131d6b"
import script from "./Tef.vue?vue&type=script&lang=js"
export * from "./Tef.vue?vue&type=script&lang=js"
import style0 from "./Tef.vue?vue&type=style&index=0&id=6c131d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports